import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setAuthSelStore } from '../../../../reducers/auth';
import PopConfirm from '../../PopConfirm';
import DropdownSelect from '../../DropdownSelect';

function selectedStoreModal({ auth, hideSelector, setMsgResetClient, closeConversation }) {
  const [storeModal, setStoreModal] = useState(false);
  const [store, setStore] = useState(auth.selectedStore);
  const [storesObj] = useState(auth.stores.reduce((acc, curr) => ({ ...acc, [curr.id]: curr.name }), {}));
  const [stores] = useState(auth.stores.filter(item => item.id));

  return (
    <>
      {!hideSelector && !!auth.selectedStore && stores.length > 1 && (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <div className="store-selector" onClick={() => setStoreModal(true)}>
          <FontAwesomeIcon icon={['far', 'location-dot']} className="store-selector__icon" />
          <span className="store-selector__name">{storesObj[auth.selectedStore]}</span>
          <FontAwesomeIcon icon={['fas', 'chevron-down']} className="store-selector__chevron" />
        </div>
      )}
      {storeModal && (
        <PopConfirm
          className="store-location-pop-confirm"
          confirm="Store Location"
          customHeaderContent="align-center fs-18"
          onCancel={() => {
            setStoreModal(false);
            setStore(auth.selectedStore);
          }}
          onConfirm={() => {
            setAuthSelStore(store);
            setStoreModal(false);
            if (closeConversation) {
              setMsgResetClient();
            }
          }}
        >
          <DropdownSelect
            options={auth.stores.filter(item => item.id).map(item => ({ label: item.name, value: item.id }))}
            placeholder="Select relationship"
            value={store}
            onChange={obj => {
              setStore(obj.value);
            }}
          />
        </PopConfirm>
      )}
    </>
  );
}

export default selectedStoreModal;
